import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";

import dark from "../../assets/images/logo-dark.svg";
import light from "../../assets/images/logo-light.svg";

const Blank = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Starter Page" pageType="Pages" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Card Title
            </h2>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <img src={dark} className="mx-auto h-12 dark:hidden" alt="" />
                <img src={light} className="mx-auto h-12 hidden dark:block" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Blank;
